import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from './api.service';
import { MfaSetupRequestDto, MfaSetupResponseDto, MfaVerifyRequestDto, MfaMethodResponseDto } from '@qc/shared/dto';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MfaService extends ApiService {
    protected get basePath(): string {
        return '/auth/mfa-methods';
    }

    getMfaMethods() {
        return this.getPaginated<MfaMethodResponseDto>('').pipe(map((response) => response.data));
    }

    setupMfaMethod(request: MfaSetupRequestDto) {
        return this.post<MfaSetupResponseDto>('', request).pipe(map((response) => response.data));
    }

    verifyOtp(mfaMethodId: string, request: MfaVerifyRequestDto) {
        return this.postVoid(`${mfaMethodId}/verify-otp`, request);
    }

    requestOtp(mfaMethodId: string) {
        return this.postVoid(`${mfaMethodId}/request-otp`);
    }

    setDefault(mfaMethodId: string, request: { code: string }) {
        return this.postVoid(`${mfaMethodId}/set-default`, request);
    }

    deleteMfaMethod(mfaMethodId: string, request: { code: string; mfaMethodId: string }) {
        return this.deleteVoid(`${mfaMethodId}`, {
            body: request,
        });
    }
}
